"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.useMessageImageSrc = void 0;
var react_1 = __importDefault(require("react"));
var GetChatImageSrcBP = __importStar(require("../blueprints/chat/get-chat-image-src"));
var contexts_1 = require("../contexts");
var react_native_1 = require("react-native");
var fetchPromises = {};
function useMessageImageSrc(messageUUID) {
    var _a;
    var BlobCache = react_1["default"].useContext(contexts_1.BlobCacheProviderContext);
    if (BlobCache == null) {
        throw new Error('BlobCacheProviderContext is null');
    }
    var call = BlobCache.client.useMutation(GetChatImageSrcBP).call;
    var _b = react_1["default"].useState((_a = BlobCache.memoryCache[messageUUID]) !== null && _a !== void 0 ? _a : null), d = _b[0], s = _b[1];
    react_1["default"].useEffect(function () {
        if (BlobCache == null) {
            throw new Error('BlobCacheProviderContext is null');
        }
        var promise = (messageUUID in fetchPromises) && fetchPromises[messageUUID].created.valueOf() > (Date.now() - 5000)
            ? fetchPromises[messageUUID].promise
            : new Promise(function (resolve) {
                react_native_1.InteractionManager.runAfterInteractions(function () {
                    if (BlobCache.memoryCache[messageUUID]) {
                        console.debug('useMessageImageSrc: returning from memCache', messageUUID, BlobCache.memoryCache[messageUUID]);
                        return s(BlobCache.memoryCache[messageUUID]);
                    }
                    console.debug('useMessageImageSrc: fetching from blob cache', messageUUID);
                    BlobCache.retrieve(messageUUID)
                        .then(function (result) {
                        if (result === null) {
                            console.debug('useMessageImageSrc: fetching from server', messageUUID);
                            call({ messageUUID: messageUUID })
                                .then(function (res) {
                                console.debug('useMessageImageSrc: fetched from server', messageUUID, res);
                                if (res.imageSrc != null) {
                                    console.debug('useMessageImageSrc: fetching image', messageUUID, res.imageSrc);
                                    BlobCache.get(messageUUID, res.imageSrc)
                                        .then(function (res) {
                                        console.debug('useMessageImageSrc: fetched image', messageUUID, res);
                                        resolve(res);
                                    })["catch"](function (e) {
                                        console.error('Error fetching image', e);
                                        resolve(null);
                                    });
                                }
                            })["catch"](console.error);
                        }
                        else {
                            resolve(result);
                        }
                    })["catch"](console.error);
                });
            });
        fetchPromises[messageUUID] = {
            promise: promise,
            created: new Date()
        };
        void promise.then(function (resolved) {
            s(resolved);
            if (resolved != null) {
                BlobCache.memoryCache[messageUUID] = resolved;
            }
        });
    }, [BlobCache, call, messageUUID]);
    return d;
}
exports.useMessageImageSrc = useMessageImageSrc;
